import StoreManager from "./data-store";
import Router from "../router";

// const host = 'http://dev.open.zheshi.tech';
const  host = 'https://zs.shslqxh.com';
const namespace = '/api/shba';
const apiVersion = '/v1';

let apiObj = {
  schedules: '/schedules', // 比赛列表 / 详情
  games: '/games', // 比赛列表 / 详情
  players: '/players', // 球员列表 球员详情

  summaries: '/summaries', // 球员比赛数据详情 比赛球员数据列表
  teams: '/teams', // 球队
  videos: '/videos', // 视频集锦
}


let methods = {
  base: {
    get(url, params, success, failure) {
      let _this = this;
      $.ajax({
        type: "GET",
        url: url,
        contentType: "application/json; charset=utf-8",
        data: params,
        dataType: "json",
        success: function (data) {
          success(data);

        },
        error: failure
      });
    },
  },

  getSchedulesList(success, failure) {
    let path = host + namespace + apiVersion + apiObj.schedules;
    this.base.get(path, null, success, failure);
  },


  getScheduleDetail(id, success, failure) {
    if (id == undefined || id == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.schedules;
    path += '/' + id
    this.base.get(path, null, success, failure);
  },

  getGamesList(success, failure) {
    let path = host + namespace + apiVersion + apiObj.games;
    this.base.get(path, null, success, failure);
  },
  getGameDetail(id, success, failure) {
    if (id == undefined || id == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.games;
    path += '/' + id
    this.base.get(path, null, success, failure);
  },

  // 获取单场比赛的球员得分进球数据
  getGamePlayerScoresData(gameId, success, failure) {
    if (gameId == undefined || gameId == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.games;
    path += '/' + gameId;
    path += '/summaries';
    this.base.get(path, null, success, failure);
  },

  // 获取单场比赛的视频列表
  getGameVideoListData(gameId, success, failure) {
    if (gameId == undefined || gameId == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.games;
    path += '/' + gameId;
    path += '/videos';
    this.base.get(path, null, success, failure);
  },


  //获取球队列表
  getTeamListData(success, failure) {
    let path = host + namespace + apiVersion + apiObj.teams;
    this.base.get(path, null, success, failure);
  },

  // 获取单只球队详情
  getTeamDetailData(teamId, success, failure) {
    if (teamId == undefined || teamId == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.teams;
    path += '/' + teamId;
    this.base.get(path, null, success, failure);
  },


  // 获取所有球员信息列表
  getPlayerListData(success, failure) {
    let path = host + namespace + apiVersion + apiObj.players;
    this.base.get(path, null, success, failure);
  },


  //获取视频集锦列表数据
  getVideosListData(success, failure) {
    let path = host + namespace + apiVersion + apiObj.videos;
    this.base.get(path, null, success, failure);
  },




  getPlayerDetail(id, success, failure) {
    if (id == undefined || id == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.players;
    path += '/' + id;
    this.base.get(path, null, success, failure);
  },

  getPlayerGameListData(success, failure) {
    let path = host + namespace + apiVersion + apiObj.summaries;
    this.base.get(path, null, success, failure);
  },

  getGameSummaryDetail(id, success, failure) {
    if (id == undefined || id == null) {
      return;
    }
    let path = host + namespace + apiVersion + apiObj.summaries;
    path += '/' + id;
    this.base.get(path, null, success, failure);
  }
};

export default methods;



// WEBPACK FOOTER //
// ./src/js/outer-games-http-define.js